import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private readonly localStorage = inject(DOCUMENT)?.defaultView?.localStorage;

  /**
   * 로컬 스토리지에 저장된 데이터를 가져옵니다.
   * @param key
   * @returns
   */
  get<T>(key: string): T | null {
    const item = this.localStorage?.getItem(key);

    if (!item) {
      return null;
    }

    return this.isJSONValid(item) ? (JSON.parse(item) as T) : (item as T);
  }

  /**
   * 로컬 스토리지에 데이터를 저장합니다.
   * @param key
   * @param value
   */
  set(key: string, value: unknown): void {
    this.localStorage?.setItem(key, JSON.stringify(value));
  }

  /**
   * 로컬 스토리지에 저장된 데이터를 삭제합니다.
   * @param key
   */
  remove(key: string): void {
    this.localStorage?.removeItem(key);
  }

  /**
   * 로컬 스토리지에 저장된 데이터를 삭제합니다.
   * @param keys
   */
  removeKeys(keys: string[]): void {
    keys.forEach((key) => this.localStorage?.removeItem(key));
  }

  /**
   *  로컬 스토리지에 저장된 모든 데이터를 삭제합니다.
   */
  clear(): void {
    this.localStorage?.clear();
  }

  private isJSONValid(value: string): boolean {
    try {
      JSON.parse(value);
      return true;
    } catch (error) {
      return false;
    }
  }
}
